import {fromLonLat} from 'ol/proj'
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import {Icon, Style} from 'ol/style'

import DefaultMarker from '../assets/map/m-work.png'
import UserMarker from '../assets/map/m-user.png'
import RestroomMarker from '../assets/map/m-restroom.png'

/**
 * Given an exhibit with a lat/lon location, convert it into an OpenLayers point teature
 * @param {*} exhibit Exhibit object from either Locly or some other source
 */
export function createMarker(exhibit, projection=null) {
    const point = projection ?
        new Point(fromLonLat([parseFloat(exhibit.longitude), parseFloat(exhibit.latitude)], projection))
        :
        new Point(fromLonLat([parseFloat(exhibit.longitude), parseFloat(exhibit.latitude)]))
    const feat = new Feature({
        geometry: point
    })
    if (exhibit.exhibitdata.data.marker_icon == 'restroom') {
        feat.setStyle(restroomMarkerStyle)
    }
    return feat
}

/**
 * Given a list of OpenLayers features, create a new VectorLayer containing those features.
 */
export function markersToLayer(markers) {
    const source = new VectorSource({
        features: markers
    })
    const layer = new VectorLayer({
        source: source,
        style: defaultMarkerStyle()
    })
    return layer
}

export function markersToSource(markers) {
    const source = new VectorSource({
        features: markers
    })
    return source
}

export function userMarker() {
    return new Feature({ style: userMarkerStyle() })
}

export function markersToUserLayer(markers) {
    const source = new VectorSource({
        features: markers
    })
    const layer = new VectorLayer({
        source: source,
        style: userMarkerStyle()
    })
    return layer
}

export function updateUserMarker(marker, latitude, longitude) {
    marker.setGeometry(new Point(fromLonLat([longitude, latitude])))
}

export function defaultMarkerStyle() {
    return new Style({
        image: new Icon({
            anchor: [0.5, 1],
            src: DefaultMarker
        })
    })
}

export function restroomMarkerStyle() {
    return new Style({
        image: new Icon({
            anchor: [0.5, 1],
            src: RestroomMarker
        })
    })
}

export function userMarkerStyle() {
    return new Style({
        image: new Icon({
            anchor: [0.5, 1],
            src: UserMarker
        })
    })
}